/**
 * NgRx Auth Actions
 *
 * Actions for authentication state management.
 * User interface unified with AuthService (Story 16.1).
 *
 * @story 16.1
 * @see HeaderComponent.logout() for dual-mechanism implementation
 * @see AuthService for auth handling (KC + mock modes)
 */
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '../../core/services/auth.service';

// Re-export User from canonical source
export { User } from '../../core/services/auth.service';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  user: User;
  token: string;
  refreshToken?: string;
}

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    // Login
    'Login': props<{ credentials: LoginRequest }>(),
    'Login Success': props<{ response: LoginResponse }>(),
    'Login Failure': props<{ error: string }>(),

    // Keycloak init (KC mode: user loaded after check-sso)
    'Keycloak Init Success': props<{ user: User; token?: string }>(),

    // Logout
    'Logout': emptyProps(),
    'Logout Success': emptyProps(),

    // Token Refresh
    'Refresh Token': emptyProps(),
    'Refresh Token Success': props<{ token: string }>(),
    'Refresh Token Failure': props<{ error: string }>(),

    // Load User
    'Load User': emptyProps(),
    'Load User Success': props<{ user: User }>(),
    'Load User Failure': props<{ error: string }>(),

    // Clear Error
    'Clear Error': emptyProps()
  }
});
